import { FETCH_DASHBOARD_START, FETCH_DASHBOARD_SUCCESS, FETCH_DASHBOARD_ERROR } from '../../actions/groupadmin/dashboardActions';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    dashboard: {},
}
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_DASHBOARD_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_DASHBOARD_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, dashboard: { ...action.dashboard } };
        }
        case FETCH_DASHBOARD_ERROR: {
            return { ...state, error: '', message: '', loading: false };
        }
        default:
            return state;
    }
}